export default "__VITE_ASSET__DvgcBrpb__"